import './styles.css';
import { Typography, Paper } from '@mui/material';
import SEO from '../../common/SEO';
import ViolinTuner from '../../common/ViolinTuner';

const TuneViolinPage = () => {
	return (
		<>
			<SEO pageName="violinTuner" />
      <Typography variant="h5" className='tuneViolinText' style={{marginBottom: 10}}>Let's tune your violin with this EasyTune tool!</Typography>
			<Paper elevation={3} 
				className="tuneViolinPaper"
        style={{ minHeight: "75vh", borderRadius: '15px',backgroundColor: ' #f5f3ef'}}>  {/**light beige color */}
        <ViolinTuner />	
      </Paper>
		</>
	)
}

export default TuneViolinPage;